/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Process_Heading_1Inputs */

const et_process_heading_1 = /** @type {(inputs: Process_Heading_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See on päris`)
};

const en_process_heading_1 = /** @type {(inputs: Process_Heading_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It's really quite`)
};

/**
* | output |
* | --- |
* | "It's really quite" |
*
* @param {Process_Heading_1Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const process_heading_1 = /** @type {((inputs?: Process_Heading_1Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Process_Heading_1Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_process_heading_1(inputs)
	return en_process_heading_1(inputs)
});